
export class RegistrationStatusModel {
  isAcceptanceStatus: boolean;
  webMessage?: string;
  statusName?: string;
}
